<template>
  <div class="category">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t("label.village") }}
        </h3>
        <div class="pull-right box-tools">
          <router-link
            v-if="can([Permissions.backend.setting.village.store])"
            :to="{ name: 'create-village' }"
            class="btn btn-primary btn-sm"
          >
            <i class="fa fa-plus-circle" /> {{ $t("button.newVillage") }}
          </router-link>
        </div>
      </div>
      <div class="box-body">
        <Datatable
          ref="oTable"
          table-id="village-table"
          url="api/backend/village/datatable"
          :columns="columns"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Permissions from '@/permissions'
import Datatable from '@/components/Datatable'

export default {
  name: 'List',
  metaInfo () {
    return {
      title: this.$t('string.villageList'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  components: { Datatable },
  data () {
    return {
      Permissions
    }
  },
  computed: {
    columns () {
      return [
        {
          data: 'name_en',
          name: 'name_en',
          title: this.$t('table.name_en')
        },
        {
          data: 'name_km',
          name: 'name_km',
          title: this.$t('table.name_km')
        },
        {
          data: 'type_' + this.$i18n.locale,
          name: 'type_' + this.$i18n.locale,
          title: this.$t('table.type')
        },
        {
          data: 'created_at',
          name: 'created_at',
          width: '200px',
          searchable: false,
          title: this.$t('table.createdAt'),
          render: (data) => {
            return this.getDateFormat(data)
          }
        },
        {
          data: 'action',
          name: 'action',
          title: this.$t('table.action'),
          width: '120px',
          orderable: false,
          searchable: false
        }
      ]
    }
  },
  mounted () {
    this.loadAction()
  },
  methods: {
    loadAction () {
      const self = this
      this.clearEventHandler([
        '.btn-delete-village',
        '.btn-edit-village'
      ])
      $(document).on('click', '.btn-delete-village', function () {
        self.onDelete($(this).attr('data-id'))
      })
      $(document).on('click', '.btn-edit-village', function () {
        self.$router.push({
          name: 'edit-village',
          params: {
            id: $(this).attr('data-id')
          }
        })
      })
    },
    onDelete (id) {
      this.onConfirm({})
        .then((accept) => {
          if (accept) {
            this.$axios.post(process.env.VUE_APP_API + '/api/backend/village/delete', {
              id: id
            }).then(() => {
              this.showSwalSuccess()
              this.$refs.oTable.draw(true)
            }).catch((error) => {
              this.onResponseError(error)
            })
          }
        })
    }
  }
}
</script>

<style scoped></style>
